var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4286_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4668 -0.0244141C9.13999 -0.0244141 15.8131 -0.0244141 22.4863 -0.0244141C23.8209 0.301107 24.651 1.13119 24.9766 2.46582C24.9766 9.13901 24.9766 15.8122 24.9766 22.4854C24.651 23.82 23.8209 24.65 22.4863 24.9756C15.8131 24.9756 9.13999 24.9756 2.4668 24.9756C1.13216 24.65 0.302083 23.82 -0.0234375 22.4854C-0.0234375 15.8122 -0.0234375 9.13901 -0.0234375 2.46582C0.302083 1.13119 1.13216 0.301107 2.4668 -0.0244141ZM4.61523 3.44238C6.34199 3.42028 8.06729 3.4447 9.79102 3.51562C10.3084 3.69119 10.642 4.04113 10.792 4.56543C10.8246 9.62729 10.8246 14.6891 10.792 19.751C10.642 20.2753 10.3084 20.6252 9.79102 20.8008C8.06719 20.8798 6.34194 20.8961 4.61523 20.8496C3.96031 20.8031 3.529 20.4694 3.32129 19.8486C3.24034 14.7889 3.22406 9.72705 3.27246 4.66309C3.43759 3.93608 3.88519 3.52918 4.61523 3.44238ZM15.5039 3.44238C17.1153 3.43425 18.7267 3.44238 20.3379 3.4668C21.0763 3.53778 21.5238 3.93654 21.6807 4.66309C21.7132 7.56021 21.7132 10.4574 21.6807 13.3545C21.5442 14.0117 21.1455 14.4105 20.4844 14.5508C18.7754 14.5833 17.0664 14.5833 15.3574 14.5508C14.7264 14.4351 14.3276 14.0688 14.1611 13.4521C14.1286 10.4899 14.1286 7.52769 14.1611 4.56543C14.3677 3.89448 14.8152 3.52013 15.5039 3.44238Z",
    fill: "#518FE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4286_2468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.d99e4144dee21bef8b0e8b7bcac9295b.svg";
export { ForwardRef as ReactComponent };